var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Provider } from 'react-redux';
import { ReduxContext } from '@employee-experience/common/lib/ReduxContext';
import { useSelector, ReactReduxContext } from 'react-redux';
export function withStore(storeBuilderResult) {
    const { store, context } = storeBuilderResult, otherResults = __rest(storeBuilderResult, ["store", "context"]);
    return (WrappedComponent) => {
        const ComponentWithStore = (
        // eslint-disable-next-line @typescript-eslint/ban-types
        props) => {
            const { children } = props;
            return (React.createElement(Provider, { store: store },
                React.createElement(ReduxContext.Provider, { value: Object.assign({ dispatch: store.dispatch, useSelector, __redux_context__: ReactReduxContext }, otherResults) },
                    React.createElement(WrappedComponent, Object.assign({}, context), children))));
        };
        return ComponentWithStore;
    };
}
//# sourceMappingURL=withStore.js.map